module.exports = __webpack_public_path__ + "img/icon_ai_matching.c2d0895c.svg";